import { render, staticRenderFns } from "./CompanyRanges.vue?vue&type=template&id=73b06504&"
import script from "./CompanyRanges.vue?vue&type=script&lang=ts&"
export * from "./CompanyRanges.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports